import React from 'react';
import T from 'prop-types';

import { FLEX_DRAFT_SETUP_DICTIONARY } from '@dmi/shared/redux/Payments/FlexDraft/constants';

import { StyledScrollView } from '../../../base_ui';
import { SecondaryHeader } from '../../../ScreenHeaders';
import {
  AddressHeader,
  PaymentSummary,
  RowButton,
} from '../../sharedComponents';
import { ContentContainer, StyledDivider } from './styledComponents';

const SetupOverview = ({
  address,
  maskedLoanNumber,
  navigation,
  paymentDueDate,
  paymentSummarySubText,
  setUpRowButtonsProps: {
    amountRowValue,
    noPaymentSchedule,
    noPaymentSource,
    paymentScheduleErrorLabel,
    paymentScheduleRowSubText,
    paymentScheduleRowValue,
    paymentSourceErrorLabel,
    paymentSourceRowValue,
  },
}) => {
  const { headerText, summaryButtonLabel } = FLEX_DRAFT_SETUP_DICTIONARY;

  return (
    <StyledScrollView showsVerticalScrollIndicator={false} stickyHeaderIndices={[0]}>
      <SecondaryHeader
        handleBack={() => navigation.goBack()}
        title={headerText}
      />
      <AddressHeader address={address} dueDate={paymentDueDate} loanNumber={maskedLoanNumber} />
      <ContentContainer>
        <StyledDivider />
        <RowButton
          accessibilityName="amount"
          handlePress={() => navigation.navigate('FlexDraftAmount')}
          label="Amount"
          value={amountRowValue}
        />
        <StyledDivider />
        <RowButton
          accessibilityName="pay-from"
          handlePress={() => navigation.navigate('FlexDraftSource')}
          label="Pay From"
          noPaymentSource={noPaymentSource}
          noValueErrorLabel={paymentSourceErrorLabel}
          value={paymentSourceRowValue}
        />
        <StyledDivider />
        <RowButton
          accessibilityName="payment-schedule"
          handlePress={() => navigation.navigate('FlexDraftScheduleSelect')}
          label="Payment Schedule"
          labelSubText={paymentScheduleRowSubText}
          noPaymentSchedule={noPaymentSchedule}
          noValueErrorLabel={paymentScheduleErrorLabel}
          value={paymentScheduleRowValue}
        />
        <StyledDivider />
      </ContentContainer>
      <PaymentSummary
        disabled={noPaymentSchedule || noPaymentSource}
        label={summaryButtonLabel}
        onPress={() => navigation.navigate('FlexDraftReview')}
        subText={paymentSummarySubText}
        text={amountRowValue}
      />
    </StyledScrollView>
  );
};

SetupOverview.propTypes = {
  address: T.string.isRequired,
  maskedLoanNumber: T.string.isRequired,
  navigation: T.object.isRequired,
  paymentDueDate: T.string.isRequired,
  paymentSummarySubText: T.string.isRequired,
  setUpRowButtonsProps: T.shape({
    amountRowValue: T.string.isRequired,
    noPaymentSchedule: T.bool.isRequired,
    noPaymentSource: T.bool.isRequired,
    paymentScheduleErrorLabel: T.string.isRequired,
    paymentScheduleRowSubText: T.string.isRequired,
    paymentScheduleRowValue: T.string.isRequired,
    paymentSourceErrorLabel: T.string.isRequired,
    paymentSourceRowValue: T.string.isRequired,
  }).isRequired,
};

export default SetupOverview;
